import React, { memo } from 'react';
import {
	Divider,
	Icon,
	Popup
} from 'semantic-ui-react';

import { useAuthState } from '../../contexts/AuthContext';

import TextButton from '../Shared/TextButton';

import styles from './header.module.css';

const UserProfile = () => {
	const { user } = useAuthState();

	return (
		<Popup
			className={ styles.userProfile }
			flowing
			hoverable
			position="top right"
			trigger={ <TextButton buttonText="User&nbsp;Profile" /> }
			wide="very"
		>
			<Popup.Content className={ styles.content }>
				<Icon
					name="user"
					size="big"
				/>
				<h4 className={ styles.role }>
					{ user.role.name }
				</h4>
				<span className={ styles.site }>
					{ user.profile.organization.name }
				</span>
				<Divider />
				<p className={ styles.field }>
					<span className={ styles.fieldName }>Name</span>
					<br/>
					<span className={ styles.fieldValue }>{ `${ user.profile.firstName } ${ user.profile.lastName }` }</span>
				</p>
				<p className={ styles.field }>
					<span className={ styles.fieldName }>Username</span>
					<br/>
					<span className={ styles.fieldValue }>{ user.userName }</span>
				</p>
				<p className={ styles.field }>
					<span className={ styles.fieldName }>Email Address</span>
					<br/>
					<span className={ styles.fieldValue }>{ user.profile.email }</span>
				</p>
			</Popup.Content>
		</Popup>
	);
};

export default memo( UserProfile );
